import React, { useState } from 'react'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import { Grid, Card, CardContent, Typography, CardHeader } from '@material-ui/core/'
import { deepOrange } from '@material-ui/core/colors';
import Colors from '../../../Global/colors'
import SearchOutlinedIcon from '@material-ui/icons/SearchOutlined';
import LinearProgress from '@material-ui/core/LinearProgress';
import Tooltip from "@material-ui/core/Tooltip";
import SpeedIcon from '@material-ui/icons/Speed';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
// import { Progress } from 'rsuite';
import Paper from '@material-ui/core/Paper';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
// import { ProgressBar } from './ProgressBar';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(2)
    },
    root2: {
        flexGrow: 1,
        padding: theme.spacing(1),
        alignContent: 'center'
        // width: 600
    },
    card: {
        maxWidth: 345,
    },
    title: {
        fontSize: 19,
    },
    chartOneTitle: {
        fontSize: 12,
        fontWeight: 'bold',
        color: 'white',
        textAlign: 'center',
        marginBottom:5
    },
    iconColor: {
        color: deepOrange['300'],
        fontSize: 18,
        marginTop: 10,
    },
    button: {
        padding: 0,
        paddingLeft: 12,

    },
    header: {
        padding: 0,
        paddingLeft: 5
    }
}))


export const StatusandFilters = () => {
    const classes = useStyles()
    const [ status, changeStatus] = useState({ 'inprogress': 85.19, 'submitted': 50, approved: 90, rejected: 5 })

    return <div className={classes.root}>
        <Grid container spacing={2} direction="row" justify="flex-start" alignItems="flex-start">
          {/* <Grid item xs={12} sm={6} md={3}>
                    <Card style={{ borderRadius: 15 }}>
                        <CardHeader
                            title={`Title : `}
                            subheader={`Sub Heading : `}
                        />
                        <CardContent>
                            <Typography variant="h5" gutterBottom>
                                Card One
                                </Typography>
                        </CardContent>
                    </Card>
                </Grid> */}
          <Grid item xs={12} sm={6} md={3}>
            <Card style={{ borderRadius: 15 }}>
              <CardHeader style={{ position: "relative" }} classes={{ root: classes.header }} title={<div className={classes.title}>
                    <SpeedIcon className={classes.iconColor} /> <p className="filterHeading" style={{ color: "#306086", justifyContent: "left", display: "flex", fontSize: 14, fontWeight: "bold", marginTop: 0, marginBottom: 0 }}>
                      Status & Filters
                    </p>
                    
                  </div>} />
              <CardContent>
                <Grid container spacing={2} direction="row" justify="center" alignItems="center">
                  // className={classes.root2}
                  {/* <Grid container
                                    spacing={2}
                                    direction="row"
                                    justify="center"
                                    alignItems="center"
                                    className={classes.root2}
                                > */}
                  <Grid item lg={6} xs={6} sm={6} md={6}>
                    <Card style={{ backgroundColor: "#25c2ed", borderRadius: 15 }}>
                      <CardContent>
                        <>
                          <div className={classes.chartOneTitle}>
                            Inprogress
                          </div>
                          <div style={{ width: 60 }}>
                            <CircularProgressbar value={status.inprogress} text={`${status.inprogress}%`} background={true} styles={buildStyles(
                                {
                                  textSize: "25px",
                                  textColor: "#25c2ed",
                                  pathColor: "#6fd6f3",
                                  backgroundColor: "white",
                                  trailColor: "#25c2ed",
                                }
                              )} />
                          </div>
                        </>
                      </CardContent>
                    </Card>
                    {/* <Paper elevation={0}
                                            classes={classes.chartOneTitle}
                                            children={<><div>Inprogress</div><div><ProgressBar /></div></>} /> */}
                  </Grid>
                  <Grid item lg={6} xs={6} sm={6} md={6}>
                    <Card style={{ backgroundColor: "#ff9248", borderRadius: 15 }}>
                      <CardContent>
                        <>
                          <div className={classes.chartOneTitle}>
                            Submitted
                          </div>
                          <div style={{ width: 60 }}>
                            <CircularProgressbar value={status.submitted} text={`${status.submitted}%`} background={true} styles={buildStyles(
                                {
                                  textSize: "25px",
                                  textColor: "#ff9248",
                                  pathColor: "#ffb583",
                                  backgroundColor: "white",
                                  trailColor: "#ff9248",
                                }
                              )} />
                          </div>
                        </>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
                <Grid container spacing={2} direction="row" justify="center" alignItems="center">
                  // className={classes.root2}
                  <Grid item lg={6} xs={6} sm={6} md={6}>
                    <Card style={{ backgroundColor: "#00ad1e", borderRadius: 15 }}>
                      <CardContent>
                        <>
                          <div className={classes.chartOneTitle}>
                            Approved
                          </div>
                          <div style={{ width: 60 }}>
                            <CircularProgressbar value={status.approved} text={`${status.approved}%`} background={true} styles={buildStyles(
                                {
                                  textSize: "25px",
                                  textColor: "#00ad1e",
                                  pathColor: "#78d387",
                                  backgroundColor: "white",
                                  trailColor: "#00ad1e",
                                }
                              )} />
                          </div>
                        </>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item lg={6} xs={6} sm={6} md={6}>
                    <Card style={{ backgroundColor: "#ee1717", borderRadius: 15 }}>
                      <CardContent>
                        <>
                          <div className={classes.chartOneTitle}>
                            Rejected
                          </div>
                          <div style={{ width: 60 }}>
                            <CircularProgressbar value={status.rejected} text={`${status.rejected}%`} background={true} styles={buildStyles(
                                {
                                  textSize: "25px",
                                  textColor: "#ee1717",
                                  pathColor: "#f67d7d",
                                  backgroundColor: "white",
                                  trailColor: "#ee1717",
                                }
                              )} />
                          </div>
                        </>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
                {/* </Grid> */}
              </CardContent>
            </Card>
          </Grid>
          {/* <Grid item xs={12} sm={6} md={3}>
                    <Card style={{ borderRadius: 15 }}>
                        <CardHeader
                            title={`Title : `}
                            subheader={`Sub Heading : `}
                        />
                        <CardContent>
                            <Typography variant="h5" gutterBottom>
                                Card Four
                                </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Card style={{ borderRadius: 15 }}>
                        <CardHeader
                            title={`Title : `}
                            subheader={`Sub Heading : `}
                        />
                        <CardContent>
                            <Typography variant="h5" gutterBottom>
                                Card Four
                                </Typography>
                        </CardContent>
                    </Card>
                </Grid> */}
        </Grid>
      </div>;
}